<template>
	<SidePanelContent :type="SidebarContent.GUIDE" with-close-bar hide-on-click-outside class="w-[45.125rem]">
		<template #heading>How to set effective discounts and why?</template>

		<div class="font-body-l-bold mb-05 mt-03">How deep should discounts be?</div>

		<div class="font-body-m">
			There is no short nor simple answer to that. It depends on factors like lifecycle, performance, and discount history. We've got you covered
			with the Advisor feature. It takes into account the history of 75,000+ SKUs, checks your product performance so far, then produces the best
			discount recommendation possible.
			<!-- This part will become visible once we have a dashboard to redirect to (https://indiebi.atlassian.net/browse/SAAS-1266)
			Take a look at your
			<a class="link font-bold text-primary-100">product's history</a> to get more context.
			-->
		</div>

		<div class="mt-5">
			<img src="@/assets/how_deep.svg" class="w-[32rem]" />
		</div>

		<div class="font-body-l-bold mb-05 mt-09">How often should events be scheduled?</div>

		<div class="font-body-m">
			We say the more, the better! However, keep an eye out for potential clashes with global events like the Steam Winter Sale, and mind the
			cooldown periods. Don't worry, we've got you covered here as well with the Autoplanner. Our algorithm analyzes everything, ensuring optimal
			periods for your events. If you prefer to do it all by yourself that's fine!
			<br />
			<span class="link inline-flex font-bold text-primary-100">
				<a @click="openGuide">Check our guide</a><mdicon class="ml-02 mr-04" name="open-in-new" />
			</span>
			to find helpful tips for that.
		</div>

		<div class="mt-7">
			<img src="@/assets/how_often.svg" class="w-[41rem]" />
		</div>
	</SidePanelContent>
</template>

<script setup lang="ts">
import { openLink } from '@/common/utils'
import SidePanelContent from '@/features/sidePanel/components/SidePanelContent.vue'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { SidebarContent } from '@/types'

const { trackEvent } = useTelemetry()

const guideLink = 'https://indiebi.notion.site/Effective-discounting-2474dcd11fb446b8826b154d8849f5a2'

function openGuide() {
	trackEvent('user', 'Opened user guide notion page.')

	openLink(guideLink)
}
</script>

<style scoped lang="scss">
.footer {
	background-color: theme('colors.primary.12');
}

.steam {
	color: theme('colors.portals.primary.steam');
}
</style>
